import {SafePipe} from './safe.pipe';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MDBBootstrapModule} from 'angular-bootstrap-md';
import {OwlModule} from 'ngx-owl-carousel';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
// import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HomeComponent} from './home/home.component';
import {ZinuzhComponent} from './zinuzh/zinuzh.component';
import {HayzinvorComponent} from './hayzinvor/hayzinvor.component';
import {NgxPaginationModule} from 'ngx-pagination';
import {AsparComponent} from './aspar/aspar.component';
import {LrahosComponent} from './lrahos/lrahos.component';
import {ArchiveComponent} from './archive/archive.component';
import {AboutusComponent} from './aboutus/aboutus.component';
import {ContactusComponent} from './contactus/contactus.component';
import {HayzinvorDetalesComponent} from './hayzinvor-detales/hayzinvor-detales.component';
import {ZinuzhArchiveComponent} from './zinuzh-archive/zinuzh-archive.component';
import {HayzinvorArchiveComponent} from './hayzinvor-archive/hayzinvor-archive.component';
import {AsparArchiveComponent} from './aspar-archive/aspar-archive.component';
import {TesanyuterComponent} from './tesanyuter/tesanyuter.component';
import {PhotosComponent} from './photos/photos.component';
import {SongsComponent} from './songs/songs.component';

import {SwiperModule} from 'angular2-useful-swiper';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatVideoModule} from 'mat-video';
// import { HttpModule, JsonpModule } from '@angular/http';
import {AlbomComponent} from './albom/albom.component';
import {SongItemComponent} from './song-item/song-item.component';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {NewsDetalesComponent} from './news-detales/news-detales.component';
import {ZinvorArchiveItemComponent} from './zinvor-archive-item/zinvor-archive-item.component';
import {ZinvorArchiveNewsComponent} from './zinvor-archive-news/zinvor-archive-news.component';
import {APP_BASE_HREF, LocationStrategy, HashLocationStrategy} from '@angular/common';
import {RoutingComponentComponent} from './routing-component/routing-component.component';
import {EncodeUriPipe} from './encode-uri.pipe';
import {NoopInterceptor} from '@angular/common/http/src/interceptor';
import {SendHeadersService} from './send-headers.service';
import {VideosCategoryComponent} from './videos-category/videos-category.component';
import {SongCategoryComponent} from './song-category/song-category.component';
import {SearchResoultComponent} from './search-resoult/search-resoult.component';
// import { [safe]Pipe } from './[safe].pipe';

import {JwSocialButtonsModule} from 'jw-angular-social-buttons';
import {DlDateTimeDateModule, DlDateTimePickerModule} from 'angular-bootstrap-datetimepicker';
import {ZinujXoragirComponent} from './zinuj-xoragir/zinuj-xoragir.component';
import {AsparKhoragirComponent} from './aspar-khoragir/aspar-khoragir.component';
import {HayzinvorXoragirComponent} from './hayzinvor-xoragir/hayzinvor-xoragir.component';
import {ArchiveLiveComponent} from './archive-live/archive-live.component';
import {NGXLogger, LoggerModule, NgxLoggerLevel} from 'ngx-logger';
import {environment} from 'src/environments/environment';
import {WorkersComponent} from './workers/workers.component';
import {HeaderBackgroundService} from './header-background.service';
import {ZoratesaknerComponent} from './zoratesakner/zoratesakner.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {Globals} from './globals';
import 'hammerjs'; // <------ mandatory dependency for angular-modal-gallery
import 'mousetrap'; // <------ mandatory dependency for angular-modal-gallery
import {ModalGalleryModule} from 'angular-modal-gallery';
import {NgxImageGalleryModule} from 'ngx-image-gallery';
import {OpenLinkInNewWindowDirective} from './olinw.directive';
import {BackRoutingStateService} from './back-routing-state.service';
import {AdvancedSearchComponent} from './header/advanced-search/advanced-search.component';
import {MatDialog, MatDialogModule} from '@angular/material';
import {FacebookService} from './facebook.service';

@NgModule({
  declarations: [
    SafePipe,
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    ZinuzhComponent,
    HayzinvorComponent,
    AsparComponent,
    LrahosComponent,
    ArchiveComponent,
    AboutusComponent,
    ContactusComponent,
    HayzinvorDetalesComponent,
    ZinuzhArchiveComponent,
    HayzinvorArchiveComponent,
    AsparArchiveComponent,
    TesanyuterComponent,
    PhotosComponent,
    SongsComponent,
    AlbomComponent,
    SongItemComponent,
    NewsDetalesComponent,
    ZinvorArchiveItemComponent,
    ZinvorArchiveNewsComponent,
    OpenLinkInNewWindowDirective,
    RoutingComponentComponent,
    EncodeUriPipe,
    VideosCategoryComponent,
    SongCategoryComponent,
    SearchResoultComponent,
    ZinujXoragirComponent,
    AsparKhoragirComponent,
    HayzinvorXoragirComponent,
    ArchiveLiveComponent,
    WorkersComponent,
    ZoratesaknerComponent,
    NotFoundComponent,
    AdvancedSearchComponent,
    // [safe]Pipe, SafePipe
  ],
  imports: [
    BrowserModule,
    OwlModule,
    BrowserAnimationsModule,
    NgxPaginationModule,
    FormsModule,
    MatDialogModule,
    // HttpModule,
    JwSocialButtonsModule,
    SwiperModule,
    BrowserAnimationsModule,
    NgxImageGalleryModule,
    MatVideoModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    DlDateTimeDateModule,
    DlDateTimePickerModule,
    ModalGalleryModule.forRoot(),
    LoggerModule.forRoot({
      level: !environment.production ? NgxLoggerLevel.LOG : NgxLoggerLevel.OFF,

      serverLogLevel: NgxLoggerLevel.OFF
    })
  ],
  providers: [
    Globals,
    BackRoutingStateService,
    HeaderBackgroundService,
    {provide: APP_BASE_HREF, useValue: '/'},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SendHeadersService,
      multi: true,
    }

  ],
  entryComponents: [
    AdvancedSearchComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule  implements OnInit {
  constructor(private facebookService: FacebookService) {
    console.log('sssssss');
    this.facebookService.loadSdk();

  }

  ngOnInit(): void {
    console.log('sssssss');
  }
}
